<template>
  <div id="container">
    <div class="box">
      <div class="inner">
        <div class="inner-item" >
          <el-container>
            <!-- <router-link :to="{ name: 'Home' }">
              <el-aside width="289px" class="aside"
              style="background-size:contain"
              :style="{ backgroundImage : 'url( '+ logoImg + ')'   }" ></el-aside>
            </router-link> -->
            <el-main style="overflow:hidden;padding:0" class="amain">

            </el-main>
          </el-container>
        </div>
      </div>

      <div class="main_cont">
        <div style="position:relative;width:1100px;margin:0 auto">
          <div class="logo_cont">
            <div style="text-align:center;margin-top:11px">
              <el-image
                style="width: 325px; height: 325px;"
                class="product_image"
                :src='u29'
                fit="contain"
              ></el-image>
            </div>
            <div style="font-size: 20px;color: #999999;text-align:center;margin-top:43px">
              扫描小程序二维码
            </div>
            <div style="font-size: 20px;color: #999999;text-align:center;margin-top:8px">
              注册成为经销商
            </div>

          </div>
          <div class="login_cont">
            <div style="text-align:center;margin-top:5px">
              <el-image
                style="width:260px;"
                class="product_image"
                :src='pc_logo'
                fit="contain"
              ></el-image>
            </div>

            <div style="margin: 21px 0;font-size: 20px;color: #999999 ;line-height: 36px;text-align:center">
              用户登录
            </div>

            <el-form ref="form" :model="form" :rules="rules" style="width:300px;margin:0 auto">
              <el-form-item style="height:50px" prop="username">
                <el-input
                  v-model="form.username"
                  placeholder="手机号码"
                >
                  <i slot="prefix" class="el-input__icon el-icon-user-solid" style="font-size:20px"></i>
                </el-input>
              </el-form-item>
              <el-form-item style="margin-bottom:10px" prop="password" >
                <el-input
                  v-model="form.password"
                  placeholder="输入登录密码"
                  type="password"
                >
                  <i slot="prefix" class="el-input__icon el-icon-lock" style="font-size:20px;"></i>
                </el-input>
              </el-form-item>
              <el-form-item style="margin-bottom:10px">
                <el-checkbox v-model="checked" class="sidentify">记住密码</el-checkbox>
              </el-form-item>

              <div class="parallelogram" style="margin-bottom : 17px;cursor : pointer " @click="enterClick">
                <div style="transform: skew(20deg);">登  录</div>

              </div>

              <el-button type="text" style="margin:0 auto; display : block ;color: #f90000;font-size:12px"
              @click="forgetPass"
              >忘记密码
              </el-button>

            </el-form>
          </div>
        </div>
      </div>

      <el-dialog title="修改密码" :visible.sync="passFormVisible" center   width="500px"
        :close-on-click-modal='false' :close-on-press-escape='false'
      >
        <el-image
          style="width: 100%;margin-bottom:5px"
          :src=" publicUrl + '/profile/avatar/找回1.png' "
          fit="contain"
          v-if="passStatus == 1"
        >
        </el-image>
        <el-image
          style="width: 100%;margin-bottom:5px"
          :src=" publicUrl + '/profile/avatar/找回2.png' "
          fit="contain"
          v-else-if="passStatus == 2"
        >
        </el-image>
        <div style="display:flex;margin-bottom:20px" v-if="passStatus == 1"  >
          <div style="flex:1">
            <div style="color: #E60012;text-indent:10px">进行中</div>
            <div style="color: #7F7F7F;">验证手机号码</div>
          </div>
          <div style="flex:1;text-align:center">
            <div style="color: #999999">待进行</div>
			      <div style="color: #CCCCCC;">重新设定密码</div>
          </div>
          <div style="flex:1;text-align:right">
            <div style="color: #999999;padding-right:10px">待进行</div>
			      <div style="color: #CCCCCC;">修改完成</div>
          </div>
        </div>
        <div style="display:flex;margin-bottom:20px" v-if="passStatus == 2"  >
          <div style="flex:1">
            <div style="color:#f90000;text-indent:10px">已完成</div>
            <div style="color: #CCCCCC;">验证手机号码</div>
          </div>
          <div style="flex:1;text-align:center">
            <div style="color: #f90000">进行中</div>
			      <div style="color: #AAAAAA;">重新设置密码</div>
          </div>
          <div style="flex:1;text-align:right">
            <div style="color: #999999;padding-right:10px">待进行</div>
			      <div style="color: #CCCCCC;">修改完成</div>
          </div>
        </div>

        <el-form :model="passform" ref="passform" v-if="passStatus == 1">
          <el-form-item >
            <el-input v-model="passform.phone" placeholder="请输入手机号" maxlength="11">
              <i slot="prefix" class="el-input__icon el-icon-user-solid" style="font-size:20px"></i>
            </el-input>
          </el-form-item>
          <el-form-item >
            <el-input placeholder="请输入验证码" v-model="passform.code" >
              <i slot="prefix" class="el-input__icon el-icon-lock" style="font-size:20px"></i>
              <template slot="append">

                <el-button type="text" style="width:123px;" :disabled=' disabled ' @click="bindButtonTap"> {{ passform.text }}

                </el-button>
              </template>
            </el-input>
          </el-form-item>
        </el-form>
        <el-form :model="passform" ref="passform" v-if="passStatus == 2">
          <el-form-item >
            <el-input v-model="passform.password" placeholder="设置密码" type="password">
              <i slot="prefix" class="el-input__icon el-icon-lock" style="font-size:20px"></i>
            </el-input>
          </el-form-item>
          <el-form-item >
            <el-input v-model="passform.vaidPassword" placeholder="验证密码" type="password">
              <i slot="prefix" class="el-input__icon el-icon-lock" style="font-size:20px"></i>
            </el-input>
          </el-form-item>
          <div style="color:#333;font-size:14px">
            提示:密码为字母加数字，不少于8位
          </div>
        </el-form>

        <div slot="footer" class="dialog-footer" >
          <div
            v-if="passStatus == 1"
            class="background_style btn"
            :style="{backgroundImage: 'url(' + btn_red + ')' }"
            @click.stop="gotoNextpage"
            style="cursor : pointer;margin:0 auto"
          >
            下一步
          </div>
          <div
            v-if="passStatus == 2"
            class="background_style btn"
            :style="{backgroundImage: 'url(' + btn_red + ')' }"
            @click.stop="submit"
            style="cursor : pointer;margin:0 auto"
          >
            提交
          </div>
        </div>
      </el-dialog>

      <div class="bottom">
        CopyRight @ DIXCEL {{year}}
      </div>

    </div>

  </div>
</template>

<script>
// @ is an alias to /src
// import ContOne from '@/'
import {
  login ,
  getSmsCodeReq  ,
  resetPwdReq  ,
  verifySmsCodeReq ,
} from "@/api/login/login";

export default {
  name: 'Home',
  data(){
    return {
      publicUrl : this.common.publicUrl ,
      btn_red : this.common.publicUrl + '/profile/avatar/u146.png' ,
      btn_black : this.common.publicUrl + '/profile/avatar/u147.png' ,

      logoImg :  this.common.publicUrl + '/profile/avatar/u39.png' ,

      pc_logo : this.common.publicUrl + '/profile/avatar/pc_logo.png' ,
      checked : false ,
      disabled : false , //可以发送验证
      rightCode : '' , //正确的验证码
      currentTime: 61, //倒计时
      year:  undefined, //

      form : {
        username : undefined ,
        password : undefined ,

        status : 'pc' ,
      } ,
      rules : {
        username: [
          { required: true, message: "用户名不能为空", trigger: "blur" }
        ],
        password: [
          { required: true, message: "密码不能为空", trigger: "blur" }
        ],
      } ,
      u29 :  this.common.publicUrl + '/profile/avatar/u29.png' ,
      passFormVisible : false  ,
      passStatus : 1 ,
      passform : {
        phone : '' ,
        password : '' ,
        vaidPassword : '' ,
        code : undefined ,
        text: '发送验证码', //按钮文字
      }
    }
  },
  components: {

  } ,
  created(){


      this.year = new Date().getFullYear();

    // console.log(  typeof(window.localStorage.isRemeber ) )
    if( window.localStorage.isRemeber == 'true' ){
      this.form.password = window.localStorage.password
      this.form.username = window.localStorage.username
      this.checked = true

    }else{
      window.localStorage.clear();
      this.form.password = undefined
      this.form.username = undefined
      this.checked = false
    }
  },
  methods : {
    refresh() {
      // console.log( this.$store )

    },
    // 表单重置
    reset() {
      this.form = {
        username : undefined ,
        password : undefined ,
        status : 'pc'
      };
      this.resetForm("form");

    },
    resetPassform(){
      if( this.interval ){
        clearInterval(this.interval)
      }
      this.disabled = false
      this.currentTime = 61
      this.passStatus = 1
      this.passform = {
        phone : '' ,
        code : undefined ,
        password : '' ,
        vaidPassword : '' ,
        text: '发送验证码', //按钮文字
      }
      this.$nextTick(()=>{
        this.resetForm("passform");
      })

    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    enterClick(){
      this.$refs["form"].validate(valid => {
        if (valid) {
          const loading = this.$loading({
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0)'
          });
          login(this.form).then(response => {
            loading.close()
            if (response.data.status == 0 ) {
              this.$message({
                message: '登录成功',
                type: 'success'
              });
              window.localStorage["token"] = response.data.token
              window.localStorage["goods_visible"] = response.data.goods_visible
              window.localStorage["inventory_visible"] = response.data.inventory_visible
              window.localStorage["goods_num"] = response.data.goods_num
              window.localStorage["bcm_minutes"] = response.data.bcm_minutes
              window.localStorage["minutes"] = response.data.minutes
              window.localStorage["presale_minutes"] = response.data.presale_minutes
              window.localStorage["user"] = JSON.stringify(response.data.user);
              window.localStorage["activity_bcm_status"] = response.data.activity_bcm_status
              window.localStorage["bcm_status"] = response.data.bcm_status
              window.localStorage["isRemeber"] = this.checked
              window.localStorage["username"] = this.form.username
              window.localStorage["password"] = this.form.password
              window.localStorage["priceShow"] = "0"
              window.localStorage["wxkfurl"] = response.data.wxkfurl
              window.localStorage["discount_status"] = response.data.discount_status
              window.localStorage["dealerName"] = response.data.dealerName

              // console.log( this.$store.commit("moduleUser/refresh") )
              // this.$store.commit("refresh" );
              this.$store.commit("moduleUser/refresh")

              if(this.$route.query.redirect){
                let redirect = this.$route.query.redirect;
                this.$router.push({
                  path: redirect,
                  query: { login : 1 ,}
                });
              }else{
                this.$router.push({
                  path: '/', query: { login : 1 ,}
                });
              }

              // this.$router.replace( {
              //   name : 'Home'
              // } )

            } else {
              this.$message({
                message:  response.data.statusDesc ,
                type: 'warning'
              });
            }

          });
        }
      })
    },
    forgetPass(){
      this.resetPassform()
      this.passFormVisible = true
    },
    //点击获取验证码
    bindButtonTap(){
      let currentTime = this.currentTime

      if( this.disabled ){
        return
      }
      if ( this.passform.phone == '') {
        this.$message({
          message: '请先填写手机号码',
          type: 'warning'
        });
      } else if ( this.passform.phone.trim().length != 11 || !/^1[3|4|5|6|7|8|9]\d{9}$/.test(this.passform.phone)  ){
        this.$message({
          message: '手机号码格式不正确',
          type: 'warning'
        });
      } else {
        this.disabled = true

        //设置一分钟的倒计时
        let that = this
        this.interval = setInterval(function () {
          currentTime--; //每执行一次让倒计时秒数减一

          that.passform.text = currentTime + '秒后重发'

          //如果当秒数小于等于0时 停止计时器 且按钮文字变成重新发送 且按钮变成可用状态 倒计时的秒数也要恢复成默认秒数 即让获         取验证码的按钮恢复到初始化状态只改变按钮文字

          if (currentTime <= 0) {
            clearInterval(that.interval)
            that.passform.text = '重发验证码'
            that.currentTime = 61
            that.disabled = false
          }
        }, 1000);
      }
      getSmsCodeReq({
        phone : this.passform.phone ,
        type : 2 ,
      }).then( res => {
        if (res.data.status == 0) {
          this.rightCode = res.data.code
          this.$message({
            message: '短信验证码已发送',
            type: 'warning'
          });
        }else {
          this.$message({
            message:  res.data.statusDesc ,
            type: 'warning'
          });
        }
      })

    } ,
    //点击状态2
    gotoNextpage(){
      if(  this.passform.code.length != 4 ){
        this.$message({
          message:  '验证码不正确' ,
          type: 'warning'
        });
        return
      }
      verifySmsCodeReq({
        phone : this.passform.phone ,
        code : this.passform.code
      }).then( res => {
        if (res.data.status == 0) {
          this.passStatus = 2
        }else {
          this.$message({
            message:  res.data.statusDesc ,
            type: 'warning'
          });
        }
      })



    } ,
    submit(){
      let that = this
      if( !this.passform.phone  || !this.passform.password.trim() || !this.passform.vaidPassword.trim() ){
        this.$message({
          message:  '请确认信息是否正确填写' ,
          type: 'warning'
        });
        return
      }
      if( this.passform.password.trim() !=  this.passform.vaidPassword.trim() ){
        this.$message({
          message:  '两次密码不一致' ,
          type: 'warning'
        });
        return
      }
      resetPwdReq({
        password : this.passform.password ,
        phone : this.passform.phone
      }).then( res => {
        if (res.data.status == 0) {
          this.$message({
            message: '操作成功',
            type: 'success'
          });
          this.passFormVisible = false
          this.resetPassform()
        } else {
          this.$message({
            message:  res.data.statusDesc,
            type: 'warning'
          });
          this.passFormVisible = false
          this.resetPassform()
        }
      })

    }
  },
  computed : {
    moduleUser() {
      return this.$store.state.moduleUser; // 这里返回的是：{name: 'wang', age: 22}
    }
  },
  beforeDestroy() {
    //清除定时器
    clearInterval(this.interval);
  },
}
</script>

<style lang="stylus" scoped>
#container{

}
  .inner {
    padding: 21px 10px;
    box-sizing: border-box;
    background-color : rgba(0, 0, 0 , 0%)
    width : 1200px ;
    margin: 0 auto;
  }
    .inner-item {
      border-bottom: 1px solid #fff;
      padding-bottom: 13px;
      // height: 62px;
      height: 52px;
    }


      .aside {
        overflow: hidden;
        width: 229px;
        // height: 62px;
        height: 52px;
        background-color: #fff;
        background: url("~@/assets/image/home/home1/LOGO.png");
        background-repeat : no-repeat
        background-size : cover
      }

      .amain {
        overflow: hidden;
        padding: 0;
        font-size: 15px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: rgba(0, 0, 0, 1);
        display: flex;
        justify-content: flex-start;
        align-items : center ;
      }
       .input-with-select{
         flex:1 ;
         border-radius : 10px
       }
  .main_cont {
    height 600px;
    position relative
    background-color #bccbd6;
    margin:0 auto
  }
    .logo_cont  {
      width 577px
      height 500px
      background-color #fff
      position absolute
      left 0px
      top 50px
    }
    .login_cont {
      width 380px
      height 500px
      background-color #fff
      position absolute
      right 0px
      top 50px
    }
  .bottom {
    height 120px
    line-height 120px
    background-color #f5f5f5
    text-align center
    color gray
  }

#container /deep/ .el-input__inner{
  height : 50px
}
.parallelogram {
  width: 280px;
  height: 45px;
  line-height 45px;
  font-size 14px;
  text-align center ;
  background-color : #f90000 ;
  color : #fff ;
  -webkit-transform: skew(160deg);
  -moz-transform: skew(160deg);
  -o-transform: skew(160deg);
  transform: skew(160deg);
  margin : 0 auto
}
</style>
